import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import PreloadAnimation from "./common/PreloadAnimation";
// import AiButton from "./common/AiButton";
// import AiMessenger from "./common/AiMessenger";

// pages
//import Home from "./pages/Home";
import About from "./pages/About";
import Aiva from "./pages/Aiva";
import Embedful from "./pages/Embedful";
import Resources from "./pages/Resources";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";

class App extends Component {
  render() {
    // return as array
    return [
      <Switch key="switch-key">
        {/* <Route exact path="/" component={Home} /> */}
        <Route exact path="/" component={About} />
        <Route path="/aiva" component={Aiva} />
        <Route path="/embedful" component={Embedful} />
        <Route path="/resources" component={Resources} />
        <Route path="/contact" component={Contact} />
        <Route path="/privacy" component={Privacy} />
        <Route component={About} />
      </Switch>,
      // <AiButton key="aibutton" />,
      // <AiMessenger key="aimessenger" />,
      <PreloadAnimation key="preload-key" />,
    ];
  }
}

export default App;
